/* global window, document */

import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $screen from 'wee-screen';

class HomeCalculator {
    initMobile() {
        this.updateGraph(true, $('.home__calculator-mobile_earnings-circle').data('size'));
    }

    initDesktop() {
        let tracking = false;

        this.maxValue = 0;
        this.currentValue = 0;

        $('.home__calculator-earnings_rate').each((el) => {
            const $el = $(el);
            const $rate = $el.closest('.home__calculator-earnings_rate');
            const $slider = $('.calculator_range-slide', $rate);
            const $amount = $('.calculator_range-amount', $rate);

            this.maxValue += parseInt($slider.attr('max'));

            this.updateSliderValue($rate);

            $amount.addClass('-visible');
        });

        this.updateCalculatorValue();

        $events.on({
            '.calculator_range-slide': {
                change: (e, el) => {
                    this.updateSliderValue($(el).closest('.home__calculator-earnings_rate'));

                    this.updateCalculatorValue();
                },
                mousedown: () => {
                    tracking = true;
                },
                mousemove: (e, el) => {
                    if (tracking) {
                        this.updateSliderValue($(el).closest('.home__calculator-earnings_rate'));

                        this.updateCalculatorValue();
                    }
                },
                mouseup: () => {
                    tracking = false;
                },
            },
        });
    }

    updateSliderValue($rate) {
        const $slider = $('.calculator_range-slide', $rate);
        const $amount = $('.calculator_range-amount', $rate);
        const sliderMax = parseInt($slider.attr('max'));
        const sliderMid = sliderMax / 2;
        const sliderVal = parseInt($slider.val());
        const formatted = sliderVal.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        $amount.text('$' + formatted);

        const amountPos = ($slider.val() / (sliderMax / $slider.width())) - ($amount.width() / 2);
        const offset = 12 * (1 - (sliderVal / sliderMid));

        $amount.css('left', amountPos + offset + 'px');
    }

    updateCalculatorValue() {
        this.currentValue = 0;

        $('.calculator_range-slide').each((el) => {
            this.currentValue += parseInt($(el).val());
        });

        this.updateGraph(false, (this.currentValue / this.maxValue) * 100);
    }

    updateGraph(isMobile, percent) {
        const graphClass = isMobile
            ? '.home__calculator-mobile_earnings-body'
            : '.home__calculator-earnings_body';
        const $graphBody = $(graphClass);
        const radius = $graphBody[0].r.baseVal.value;
        const circumference = radius * 2 * Math.PI;
        const offset = circumference - (percent / 100) * circumference;

        $graphBody.css('stroke-dashoffset', offset);
    }
}

export default new RouteHandler({
    init() {
        if (! $('.home__calculator').length) {
            return;
        }

        const header = new HomeCalculator();

        $screen.map([
            {
                max: 3,
                callback() {
                    header.initMobile();
                },
            },
        ]);
    },
});
